import { oldApiInstance } from 'functions/request';

export const fetchPromoSearchCouponsApi = ({ search, page, perPage }) => {
  return oldApiInstance.get(`shop/coupons?search=${search}&page=${page}&per_page=${perPage}`);
};
